import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from '@/context/CartContext';
import { ProductsProvider } from '@/context/ProductsContext';
import { ScrollToTop } from '@/components/site/ScrollToTop';
import { EditorialHome } from '@/components/site/EditorialHome';
import { CollectionPage } from '@/components/site/CollectionPage';
import { ProductPage } from '@/components/site/ProductPage';
import { AboutPage } from '@/components/site/AboutPage';
import { ContactPage } from '@/components/site/ContactPage';
import { NotFoundPage } from '@/components/site/NotFoundPage';
import { CheckoutPage } from '@/components/gallery/CheckoutPage';
import { OrderConfirmationPage } from '@/components/site/OrderConfirmationPage';
import { AdminOrdersPage } from '@/components/gallery/AdminOrdersPage';
import { AdminInquiriesPage } from '@/components/gallery/AdminInquiriesPage';
import { AdminProductsPage } from '@/components/gallery/AdminProductsPage';
import { CartDrawer } from '@/components/gallery/CartDrawer';
import { CashlessPayment } from '@/components/gallery/CashlessPayment';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <CartProvider>
        <ProductsProvider>
          <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<EditorialHome />} />
            <Route path="/books" element={<CollectionPage slug="books" />} />
            <Route path="/apparel" element={<CollectionPage slug="apparel" />} />
            <Route path="/originals" element={<CollectionPage slug="originals" />} />
            <Route path="/studio" element={<CollectionPage slug="studio" />} />
            <Route path="/products/:slug" element={<ProductPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
            <Route path="/admin" element={<AdminOrdersPage />} />
            <Route path="/admin/inquiries" element={<AdminInquiriesPage />} />
            <Route path="/admin/products" element={<AdminProductsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>

          {/* Site-wide overlays */}
          <CartDrawer />
          <CashlessPayment />
          </BrowserRouter>
        </ProductsProvider>
      </CartProvider>
    </div>
  );
}

export default App;
